import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {UtilService} from '../../services/util.service';
import {ValidationConstraint} from '../../domain/validation-constraint';
import * as _ from 'lodash';


@Component({
    selector: 'app-custom-input',
    templateUrl: './custom-input.component.html',
    styleUrls: ['./custom-input.component.scss']
})
export class CustomInputComponent implements OnInit, OnChanges {

    @Input() inputId: string;
    @Input() inputType: string;
    @Input() focus: boolean;
    @Input() disabled: boolean;
    @Input() result: any;
    @Input() styleClass: string;
    @Input() labelClass: string;
    @Input() placeholder: string;
    @Input() required: boolean;
    @Input() tabIndex: number;
    @Input() errors: object;
    @Input() modelPath: string;
    @Input() label: string;
    @Input() restrict: string;
    @Input() maxlength: number;
    @Input() unit: string;
    @Input() fieldType: string;
    @Input() rows: number;
    @Input() dataType: string;
    @Input() name: string;
    @Input() validationConstraints: ValidationConstraint[];
    @Input() readonly: boolean;
    @Input() upperCase: boolean;
    @Input() autocomplete: string;

    @Output() resultChange = new EventEmitter();
    @Output() enterKeyUp = new EventEmitter();
    @Output() enterKeyDown = new EventEmitter();
    @Output() blur = new EventEmitter();
    @Output() change = new EventEmitter();
    @ViewChild('control') input: ElementRef;
    @ViewChild('frm', {static: true}) form: any;

    public error: string;

    public fieldValidationConstraints: ValidationConstraint[];

    constructor(private cd: ChangeDetectorRef) {
    }

    ngOnInit() {
        if (this.focus) {
            setTimeout(() => this.input.nativeElement.focus(), 2000);
        }
        this.error = UtilService.getObjByPath(this.errors, this.modelPath);
        this.fieldType = this.fieldType || 'input';
        this.updataValidationConstraints();
        this.name = this.name || 'control';
        if (this.upperCase === undefined) {
            this.upperCase = false;
        }
    }

    onModelChanged($event) {
        if (this.upperCase) {
            this.result = $event.toUpperCase();
            this.resultChange.emit(this.result);
        } else {
            this.resultChange.emit($event);
        }
        this.cd.markForCheck();

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.errors !== undefined) {
            this.error = UtilService.getObjByPath(this.errors, this.modelPath);
            if (this.form.form.controls[this.name] && this.error) {
                this.form.form.controls[this.name].markAsTouched(true);
                this.form.form.controls[this.name].setErrors({backend: {someProp: 'some message'}});
            }
        }
        if (!this.error && this.form.form.controls[this.name]) {
            this.form.form.controls[this.name].markAsUntouched(true);
        }

        if (changes.validationConstraints) {
            this.updataValidationConstraints();
        }
    }

    onEnter() {
        this.enterKeyUp.emit();
    }

    onBlur($event: FocusEvent) {
        this.blur.emit();
    }

    onPaste($event: ClipboardEvent) {
    }

    private updataValidationConstraints() {
        if (this.validationConstraints !== null && this.modelPath) {
            this.fieldValidationConstraints = _.filter(this.validationConstraints, ['field', this.modelPath]);
            this.cd.markForCheck();
        }
    }

    onEnterKeyDown() {
        this.enterKeyDown.emit();
    }

    onChange() {
        this.change.emit();
    }
}

